module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/5c8c28308eedac758391483f86ea5c78.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_movecopy.svg
// module id = oeDL
// module chunks = 1